import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 20,
  pageOptions: [20, 50, 100],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
    { key: 'user_name', label: 'Username'},
    { key: 'content', label: 'probono'},
    { key: 'updated_at', label: 'Last Update'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: [],
  perPagepra: 20,
  pageOptionspra: [20, 50, 100],
  totalRowspra: 1,
  sortOptionspra: [],
  fieldspra: [
    { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
    { key: 'user_name', label: 'Username'},
    { key: 'content', label: 'probono'},
    { key: 'created_at', label: 'Last Update'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  itemspra: [],
  perPageadmin: 20,
  pageOptionsadmin: [20, 50, 100],
  totalRowsadmin: 1,
  sortOptionsadmin: [],
  fieldsadmin: [
    { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
    { key: 'user_name', label: 'Username'},
    { key: 'content', label: 'probono'},
    { key: 'updated_at', label: 'Last Update'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  itemsadmin: [],
  perPagehighlight: 20,
  pageOptionshighlight: [20, 50, 100],
  totalRowshighlight: 1,
  sortOptionshighlight: [],
  fieldshighlight: [
    { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
    { key: 'user_name', label: 'Username'},
    { key: 'content', label: 'probono'},
    { key: 'specialist', label: 'Kategori'},
    { key: 'updated_at', label: 'Last Update'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  itemshighlight: [],
  perPageprofession: 20,
  pageOptionsprofession: [20, 50, 100],
  totalRowsprofession: 1,
  sortOptionsprofession: [],
  fieldsprofession: [
    { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
    { key: 'user_name', label: 'Username'},
    { key: 'content', label: 'probono'},
    { key: 'updated_at', label: 'Last Update'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  itemsprofession: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'verification/probono/questions/unverified'}
    useIPA.get(param).then(response => {
      const verification = {
        rows : response.data.data
      }
      commit('setData', {...verification})
    })
  },
  getAllTrue ({ commit }) {
    let param = {status: 'verification/probono/questions/verified'}
    useIPA.get(param).then(response => {
      const verification = {
        rows : response.data.data
      }
      commit('setDataTrue', {...verification})
    })
  },
  getAllPra ({ commit }) {
    let param = {status: 'verification/probono/pra/questions/false'}
    useIPA.get(param).then(response => {
      const verification = {
        rowspra : response.data.data
      }
      commit('setDataPra', {...verification})
    })
  },
  getAllPraTrue ({ commit }) {
    let param = {status: 'verification/probono/pra/questions/true'}
    useIPA.get(param).then(response => {
      const verification = {
        rowspra : response.data.data
      }
      commit('setDataPra', {...verification})
    })
  },
  getAllAdmin ({ commit }) {
    let param = {status: 'verification/probono/admin/questions'}
    useIPA.get(param).then(response => {
      const verification = {
        rowsadmin : response.data.data
      }
      commit('setDataAdmin', {...verification})
    })
  },
  getAllHighlight ({ commit }) {
    let param = {status: 'verification/probono/highlights/false'}
    useIPA.get(param).then(response => {
      const verification = {
        rowshighlight : response.data.data
      }
      commit('setDataHighlight', {...verification})
    })
  },
  getAllHighlightTrue ({ commit }) {
    let param = {status: 'verification/probono/highlights/true'}
    useIPA.get(param).then(response => {
      const verification = {
        rowshighlight : response.data.data
      }
      commit('setDataHighlightTrue', {...verification})
    })
  },
  getAllProfession ({ commit }) {
    let param = {status: 'verification/professions/false'}
    useIPA.get(param).then(response => {
      const profession = {
        rowsprofession : response.data.data
      }
      commit('setDataProfession', {...profession})
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: '', url: 'dashboard/verification/probono/question', id: formData }
      useIPA.postput(param)
			.then(response => {
        // router.push({ name: 'probono-verification' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutAccept ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: '', url: 'dashboard/verification/probono/question/accept', id: formData }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'probono-verification' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutReject ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: '', url: 'dashboard/verification/probono/question/reject', id: formData }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'probono-verification' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutWarning ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: '', url: 'dashboard/verification/probono/question/warning', id: formData }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'probono-verification' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutAdmin ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const specialist = []
      // for (let is = 0, s = formData.specialistc.length; is < s; is++) {
        specialist.push({specialist_id:formData.specialistc}) 
      // }
      const rawData = {
        content: formData.reply,
        specialist: specialist
      }
      const param = { rawData: rawData, url: 'dashboard/verification/probono/admin/answer', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'probono-admin-legal' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutHighlight ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      var url = 'dashboard/verification/probono/unhighlight'
      if (formData.is_highlight === false) {
        url = 'dashboard/verification/probono/highlight'
      }
      const param = { rawData: '', url, id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'probono-highlight' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutProfession ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: '', url: 'dashboard/verification/profession', id: formData }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'verification-lp' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/profession', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, verification) {
    state.fields = [
      { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
      { key: 'user_name', label: 'Username'},
      { key: 'content', label: 'probono'},
      { key: 'updated_at', label: 'Last Update'},
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action'},
    ],
    state.items = verification.rows
    state.totalRows = verification.rows.length
  },
  setDataTrue (state, verification) {
    state.fields = [
      { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
      { key: 'user_name', label: 'Username'},
      { key: 'content', label: 'probono'},
      { key: 'updated_at', label: 'Last Update'},
      { key: 'status', label: 'Status', sortable: true },
    ],
    state.items = verification.rows
    state.totalRows = verification.rows.length
  },
  setDataPra (state, verification) {
    state.itemspra = verification.rowspra
    state.totalRowspra = verification.rowspra.length
  },
  setDataAdmin (state, verification) {
    state.itemsadmin = verification.rowsadmin
    state.totalRowsadmin = verification.rowsadmin.length
  },
  setDataHighlight (state, verification) {
    state.fieldshighlight = [
      { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
      { key: 'user_name', label: 'Username'},
      { key: 'content', label: 'probono'},
      { key: 'specialist', label: 'Kategori'},
      { key: 'updated_at', label: 'Last Update'},
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action'}
    ],
    state.itemshighlight = verification.rowshighlight
    state.totalRowshighlight = verification.rowshighlight.length
  },
  setDataHighlightTrue (state, verification) {
    state.fieldshighlight = [
      { key: 'user_fullname', label: 'Nama Lengkap', sortable: true },
      { key: 'user_name', label: 'Username'},
      { key: 'content', label: 'probono'},
      { key: 'specialist', label: 'Kategori'},
      { key: 'updated_at', label: 'Last Update'},
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action'}
    ],
    state.itemshighlight = verification.rowshighlight
    state.totalRowshighlight = verification.rowshighlight.length
  },
  setDataProfession (state, profession) {
    state.itemsprofession = profession.rowsprofession
    state.totalRowsprofession = profession.rowsprofession.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
